import { css } from 'linaria';

export const productStickyPanelContainer = css`
  width: 100%;
`;

export const productStickyPanel = css`
  height: 0;
  overflow: hidden;
  background-color: var(--background-primary);
  box-shadow: 0 1.17px 2px 0 rgb(0 0 0 / 2%), 0 1.4px 5px 0 rgb(0 0 0 / 3%),
    0 2px 10px 0 rgb(0 0 0 / 3%), 0 2px 18px 0 rgb(0 0 0 / 4%), 0 9px 33px 0 rgb(0 0 0 / 3%);
  transform: translateY(-100%);
`;

export const fixedProductStickyPanel = css`
  height: auto;
  transform: translateY(0);
`;

export const productStickyPanelContent = css`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 17px 0;
`;

export const productStickyPanelNameContainer = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const productStickyPanelNameWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 25px;
  row-gap: 2px;
`;

export const productStickyPanelPriceWrapper = css`
  display: flex;
  align-items: center;
  column-gap: 25px;

  @media (--only-mobile) {
    flex-direction: column;
    row-gap: 7px;
  }
`;

export const productStickyPanelPrice = css`
  && {
    width: max-content;
    font-weight: 700;
  }
`;

export const productStickyPanelBtn = css`
  && {
    height: 40px;
    padding: 10px 22px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    @media (--only-mobile) {
      height: 35px;
    }
  }
`;
